(function () {
  var SELECTOR = '.new-arrivals-section .products, .all-products-section .products';
  var initialized = window.__woodarqHomeProductSlidersInitialized || new WeakSet();
  window.__woodarqHomeProductSlidersInitialized = initialized;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function initStrip(strip) {
    if (!strip || initialized.has(strip)) return;
    initialized.add(strip);

    strip.setAttribute('data-woodarq-horizontal-scroll', 'true');

    strip.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    var isPointerDown = false;
    var isMouseDrag = false;
    var hasPointerCapture = false;
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var hasDragged = false;
    var suppressClick = false;
    var suppressTimer = null;
    var activePointerId = null;
    var DRAG_THRESHOLD = 6;
    var CLICK_SUPPRESS_MS = 450;

    function canScroll() {
      return strip.scrollWidth > strip.clientWidth + 2;
    }

    function capturePointer(event) {
      if (hasPointerCapture || !strip.setPointerCapture || !event || event.pointerId == null) return;

      try {
        strip.setPointerCapture(event.pointerId);
        hasPointerCapture = true;
      } catch (error) {}
    }

    function releasePointer(event) {
      if (!hasPointerCapture || !strip.releasePointerCapture || !event || event.pointerId == null) return;

      try {
        strip.releasePointerCapture(event.pointerId);
      } catch (error) {}

      hasPointerCapture = false;
    }

    function suppressNextClick() {
      suppressClick = true;
      window.clearTimeout(suppressTimer);
      suppressTimer = window.setTimeout(function () {
        suppressClick = false;
        hasDragged = false;
      }, CLICK_SUPPRESS_MS);
    }

    function endDrag(event) {
      if (!isPointerDown) return;

      var shouldSuppress = hasDragged;

      isPointerDown = false;
      isMouseDrag = false;
      activePointerId = null;
      strip.classList.remove('is-dragging');
      releasePointer(event);

      if (shouldSuppress) suppressNextClick();
    }

    strip.addEventListener('pointerdown', function (event) {
      if (!canScroll()) return;
      if (event.button != null && event.button !== 0) return;

      isPointerDown = true;
      isMouseDrag = event.pointerType !== 'touch';
      hasPointerCapture = false;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = strip.scrollLeft;
      hasDragged = false;
      activePointerId = event.pointerId;

      /* Do not capture the pointer on mousedown. Capturing immediately retargets
         the desktop click to the strip instead of the product link, which makes
         product cards look clickable but prevents navigation. Capture only after
         the user has clearly started dragging. */
    });

    strip.addEventListener(
      'pointermove',
      function (event) {
        if (!isPointerDown) return;
        if (activePointerId != null && event.pointerId !== activePointerId) return;

        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;
        var horizontalMove = Math.abs(deltaX);
        var verticalMove = Math.abs(deltaY);

        if (!isMouseDrag) {
          if (horizontalMove > DRAG_THRESHOLD || verticalMove > DRAG_THRESHOLD) {
            hasDragged = true;
          }
          return;
        }

        if (horizontalMove > DRAG_THRESHOLD) {
          hasDragged = true;
          capturePointer(event);
          strip.classList.add('is-dragging');
          strip.scrollLeft = startScrollLeft - deltaX;
          event.preventDefault();
        }
      },
      { passive: false }
    );

    strip.addEventListener('pointerup', endDrag);
    strip.addEventListener('pointercancel', endDrag);
    strip.addEventListener('pointerleave', function (event) {
      if (!isMouseDrag || hasPointerCapture) return;
      endDrag(event);
    });

    strip.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    strip.addEventListener(
      'wheel',
      function (event) {
        if (!canScroll()) return;

        var useVerticalWheelAsHorizontal = event.shiftKey;
        var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : useVerticalWheelAsHorizontal ? event.deltaY : 0;
        if (!delta) return;

        var maxScroll = strip.scrollWidth - strip.clientWidth;
        var nextScroll = clamp(strip.scrollLeft + delta, 0, maxScroll);
        if (nextScroll === strip.scrollLeft) return;

        strip.scrollLeft = nextScroll;
        event.preventDefault();
      },
      { passive: false }
    );
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initStrip);
  }

  window.WoodarqHomeProductSliders = window.WoodarqHomeProductSliders || {};
  window.WoodarqHomeProductSliders.init = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (!window.__woodarqHomeProductSlidersObserver) {
    var observerTimer = null;
    window.__woodarqHomeProductSlidersObserver = new MutationObserver(function () {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(initAll, 50);
    });
    window.__woodarqHomeProductSlidersObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
